import React, { useEffect, useState } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';



const Requisitions = () => {
    
  const [myRequisitions, setMyRequisitions] = useState([]);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const theUserType = localStorage.getItem('userType');
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.state?.defaultTab || "All"
  );
  const storedFullName = localStorage.getItem('fullName');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    console.log("Full name", storedFullName);
};

 


  const handleView = (requisitionID) => {
      navigate(`/view-requisition/${requisitionID}`);
  };

  const handleSurrender = (requisitionID) => {
    navigate(`/surrender/${requisitionID}`);
};

  
useEffect(() => {
  const fetchRequisitions = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        console.error("User not logged in");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Requisition/user/${userId}`
      );
      const data = response.data;

      const list = Array.isArray(data) ? data : data.$values || [];

      setMyRequisitions(list);
      console.log("Fetched requisitions:", list);

      setError(null);
    } catch (err) {
      console.error("Error fetching requisitions:", err);
      setError("Error fetching requisitions.");
      setMyRequisitions([]);
    }
  };

  fetchRequisitions();
}, []);  


const fetchRequisitionsByStatus = async (reqStatus) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/Requisition/user-status`,
      {
        params: { status: reqStatus },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = response.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data.districtAndAreaProgramPairsActuals) 
      ? data
      : data.$values || [];

    setMyRequisitions(list);
    setError(null);
  } catch (err) {
    console.error("Error fetching requisitions:", err);
    if (err.response?.status === 404) {
      setError(`No requisitions found.`);
    } else if (err.response?.status === 401) {
      setError("You must be logged in to view your requisitions.");
    } else {
      setError("Error fetching requisitions.");
    }
    setMyRequisitions([]);
  }
};

useEffect(() => {
  const initialStatus = "Submitted"; 
  fetchRequisitionsByStatus(initialStatus);
}, []);

useEffect(() => {
  fetchRequisitionsByStatus(activeTab);
}, [activeTab]);

const getStatusClass = (status) => {
    if (status === "Draft") return "status-draft"; 
    if (status === "Submitted") return "status-submitted";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    if (status === "Approved") return "status-approved";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status === "Disapproved") return "status-disapproved"; 
    if (status === "Disbursed") return "status-disbursed"; 
    if (status === "To be disbursed") return "status-to-be-disbursed"; 

    
    return ""; 
  };




      
    return (
        <div id="wrapper">
          
          <Sidebar userType={theUserType} />


{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">



    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






        {/* Begin Page Content */}
        <div className="container-fluid">

            <h1 className="h3">Requisitions</h1>
            <div id="new-requisition"> 
                <Link to="/reqform" className="btn btn-primary" id="new-requisition-button">
                    <i id="plus-icon" className="fas fa-plus-circle"></i>
                    <span>New Requisition</span>
                </Link>
            </div>

           
                 {/* Tabs */}
            <div className="tabs">
              <button
                className={`nav-link ${activeTab === 'All' ? 'active' : ''}`}
                onClick={() => handleTabClick('All')}
              >
                All
              </button> 
                <button
                    className={`nav-link ${activeTab === 'Submitted' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Submitted')}
                >
                    Submitted
                </button>
                <button
                    className={`nav-link ${activeTab === 'Reviewed' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Reviewed')} 
                >
                    Reviewed 
                </button>
                <button
                    className={`nav-link ${activeTab === `Approved` ? 'active' : ''}`}
                    onClick={() => handleTabClick(`Approved`)}
                >
                    Approved
                </button>
                <button
                    className={`nav-link ${activeTab === `Disbursed` ? 'active' : ''}`}
                    onClick={() => handleTabClick(`Disbursed`)}
                >
                    Disbursed
                </button>
                <button
                    className={`nav-link ${activeTab === `Surrender Submitted` ? 'active' : ''}`}
                    onClick={() => handleTabClick(`Surrender Submitted`)}
                >
                    Surrender Submitted
                </button>
            </div>       

            <div id="requisition-table" className="table-responsive mt-4">
  <table className="table table-hover table-striped table-bordered text-sm align-middle">
    <thead className="thead-dark">
      <tr>
        <th className="text-nowrap">Activity Start Date</th>
        <th className="text-nowrap">Activity Name</th>
        <th className="text-nowrap">Activity Purpose</th>
        <th className="text-nowrap">District and AP</th>
        <th className="text-nowrap">Status</th>
        <th className="text-nowrap">Actions</th>
      </tr>
    </thead>
    <tbody>
        {myRequisitions
          .slice()
          .sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate))
          .map((requisition) => {
            const date = new Date(requisition.from);
            const formattedDate = `${date.getDate()} ${date.toLocaleString("en-US", {
              month: "long",
            })} ${date.getFullYear()}`;

      return (
        <tr key={requisition.requisitionID}>
              <td>{formattedDate}</td>
              <td>{requisition.activityName}</td>
              <td>{requisition.activityPurpose}</td>
              
              <td>
                {requisition.districtAndAreaProgramPairs?.length > 0 ? (
                  requisition.districtAndAreaProgramPairs.map((pair, index) => (
                    <div key={index}>
                      <span className="badge bg-light text-dark border mb-1">
                        {pair.district} - {pair.areaProgram}
                      </span>
                      <br />
                    </div>
                  ))
                ) : (
                  <span className="text-muted">No District and Area Program Pairs</span>
                )}
              </td>
              <td>
                <div className={`badge ${getStatusClass(requisition.status)}`}>
                  {requisition.status}
                </div>
              </td>
              <td>
                <div className="d-flex gap-2 flex-wrap">
                  <Link to={`/view-requisition/${requisition.requisitionID}`}>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleView(requisition.requisitionID)}
                    >
                      <i className="fas fa-file-alt me-1"></i> View
                    </button>
                  </Link>
                  {requisition.status === "Disbursed" && (
                    <Link to={`/surrender/${requisition.requisitionID}`}>
                      <button
                        className="btn btn-outline-success btn-sm"
                        onClick={() => handleSurrender(requisition.requisitionID)}
                      >
                        <i className="fas fa-hand-holding me-1"></i> Surrender
                      </button>
                    </Link>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
    </tbody>
  </table>
</div>

            




        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>

  );
   
};

export default Requisitions;